import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
declare let $: any;

@Component({
  selector: 'app-incubators-details',
  templateUrl: './incubators-details.component.html',
  styleUrls: ['./incubators-details.component.css'],
})
export class IncubatorsDetailsComponent implements OnInit {
  incubatorForm: FormGroup;
  buttonValue: string;
  options = [
    'Incubation Supports',
    'Workspace / technical facilities',
    'Investment',
    'Mentership',
    'Others',
  ];
  private getApi = environment.url + environment.incubatorGet;
  private incubatornewsletterlistApi =
    environment.url + environment.incubnewsletterList;
  incubatorNameList: any;

  /**
   * Component constructor.
   * Initializes the component with the specified services.
   * Creates a form group with the specified fields and validators.
   * @param route The route object.
   * @param router The router object.
   * @param makeapi The API service object.
   * @param getdata The value service object.
   * @param dialog The dialog object.
   * @param fb The form builder object.
   */
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private makeapi: ApiService,
    private getdata: ValueService,
    public dialog: MatDialog,
    private fb: FormBuilder
  ) {
    // Create a form group with the specified fields and validators
    this.incubatorForm = this.fb.group({
      // Name of the incubator
      name: ['', [Validators.required]],
      // Email of the incubator
      email: ['', [Validators.required, Validators.email]],
      // Phone number of the incubator
      phone: ['', [Validators.required]],

      // Incubator type
      incubator: [''],
      // Purpose of the query
      purpose: ['', [Validators.required]],
      // Message of the query
      message: ['', [Validators.required]],
    });
  }
  get add() {
    return this.incubatorForm.controls;
  }
  roleValue;
  /**
   * Initialize the component.
   * This method is called when the component is initialized.
   * It retrieves the role of the logged-in user from session storage,
   * and sets the visible source flag to true.
   * It also subscribes to the route query parameters and calls
   * the viewIncubator method with the _name parameter.
   * Additionally, it sets up an event listener for the "Show More" button.
   */
  ngOnInit(): void {
    // Get the role of the logged-in user from session storage
    this.roleValue = sessionStorage.getItem('role');
    // Set the visible source flag to true
    this.getdata.isVisibleSource.next(true);
    // Subscribe to the route query parameters
    this.route.queryParams
      .pipe(filter((params) => params._name))
      .subscribe((params) => {
        // Call the viewIncubator method with the _name parameter
        this.viewIncubator(params._name);
      });
    // Get the JWT token from session storage
    this.token = sessionStorage.getItem('jwttoken');
    // Set up an event listener for the "Show More" button
    $('.show-more').click(function () {
      // Toggle the show-more-height class on the .text element
      if ($('.text').hasClass('show-more-height')) {
        $(this).text('(Show Less)');
      } else {
        $(this).text('(Show More)');
      }
      $('.text').toggleClass('show-more-height');
    });
  }
  newsLetterList = [];
  newsLetterList2;
  token;
  sample = false;
  /**
   * Retrieves the list of newsletters from the API for the given incubator.
   * @param value The object containing the incubator's ID.
   * @returns An observable containing the list of newsletters.
   */
  newsletterlistApi(value) {
    // Check if the user is logged in
    if (this.token != null) {
      // API request parameters
      let req = {
        userId: value.incubatorId,
      };
      // Call the API method with the request parameters
      return this.makeapi
        .method(this.incubatornewsletterlistApi, req, 'postunauth')
        .subscribe((data) => {
          // Save the list of newsletters
          this.newsLetterList = data.responsemodelList;
        });
    } else {
      // API request parameters
      let req2 = {
        userId: value.incubatorId,
      };
      // Call the API method with the request parameters
      return this.makeapi
        .method(this.incubatornewsletterlistApi, req2, 'postunauth')
        .subscribe((data) => {
          // Save the list of newsletters
          this.newsLetterList = data.responsemodelList;
          // Set the sample flag to true
          this.sample = true;
        });
    }
  }
  profileView: any = [];
  format: any;
  incubatorName: string;
  eventStatus;
  incubatorId;
  eventList = [];
  /**
   * Gets the incubator's profile data and newsletter list based on the given username.
   * @param username The username of the incubator.
   */
  viewIncubator(username) {
    this.eventList = [];
    let replaced = username.split(' ').join('+');
    this.incubatorName = username;
    this.getdata.amizhthLoader('show');
    // Get the incubator's profile data
    this.makeapi
      .method(this.getApi + 'incubatorName=' + replaced, '', 'getunauth')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.profileView = data;
        // Get the recent events of the incubator
        data.recentEvents.forEach((element) => {
          if (element.status == 1) {
            this.eventList.push(element);
          }
        });
        // Get the YouTube video link and format it
        if (data.youtubeVideoLink) {
          let val = 'https://www.youtube.com/embed/';
          let spli = data.youtubeVideoLink.split('/');
          this.profileView.youtubeVideoLink = val + spli[3];
        }
        // Get the incubator's brochure file name and format
        if (data.incubatorBrouchureName) {
          let dat = data.incubatorBrouchureName.split('/');
          let format = dat[5].split('.');
          let final = format[1].split('?');
          this.format = final[0];
        }
        // Get the incubator's ID
        this.incubatorId = data.incubatorId;
        // Call the newsletter list API
        this.newsletterlistApi(data);
      });
  }
  /**
   * Navigates to the incubators page when the back button is clicked.
   */
  backBtn() {
    // Navigate to the incubators page
    this.router.navigateByUrl('/incubators');
  }
  /**
   * Navigates to the event details page with the given event id as a query parameter.
   * @param id The ID of the event to navigate to.
   */
  viewEvent(id: string): void {
    // Call the eventId method and pass the base64 encoded ID
    this.getdata.eventId(btoa(id));
  }
  @ViewChild('textElement') textElement: ElementRef | undefined;
  @ViewChild('showMoreButton') showMoreButton: ElementRef | undefined;

  isMore: false;
  showFullLocation: boolean[] = [];
  /**
   * Determines if the full location text should be shown based on its length.
   * @param location The location string to evaluate.
   * @returns True if the location length exceeds 20 characters, otherwise false.
   */
  shouldShowMore(location: string): boolean {
    return location.length > 20;
  }

  /**
   * Toggles the visibility of the full location text based on the index.
   * @param index The index of the location to toggle.
   */
  toggleLocation(index: number): void {
    // Toggle the visibility of the full location text
    this.showFullLocation[index] = !this.showFullLocation[index];
  }
}
